import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import numeral from 'numeral';

import { colors, grid } from '../styles';

const styles = css`
  background-color: ${colors.bodyDarker};
  ${grid.makeRow()};
  margin: 0;
  height: 100%;
  max-width: 420px;
  .CommunityCompare_imageWrapper {
    width: 98px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    display: none;
    @media(min-width: 1250px) {
      display: block;
    }
  }
  .CommunityCompare_contentWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${grid.makeCol(12)};
    @media(min-width: 1250px) {
      ${grid.makeCol(8)};
    }
    .CommunityCompare_title {
      font-weight: 700;
      font-size: 16px;
      color: ${colors.bodyDarkerTextSmall};
      letter-spacing: 0;
      line-height: 16px;
      margin: 0 0 5;
    }
    .CommunityCompare_subtitle {
      font-weight: 700;
      font-size: 12px;
      color: ${colors.bodyDarkerTextSmall};
      letter-spacing: 0;
      line-height: 16px;
      margin: 0 0 6px;
    }
    .CommunityCompare_bedsWrapper {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      li {
        font-weight: 400;
        font-size: 11px;
        color: ${colors.bodyDarkerTextSmall};
        letter-spacing: 0;
        line-height: 16px;
        & + li {
          &::before {
            content: '|';
            margin-left: 4px;
            margin-right: 4px;
          }
        }
      }
    }
  }
`;

function CommunityCompareCard({ community }) {
  const defaultImage = {
    contentUrl: '/images/default-image.jpg',
  };

  const mapImage = buildThumbnailUrl(get(community, 'photos[0].contentUrl'), { width: 800, height: 800, preserve: true }) || get(defaultImage, 'contentUrl');
  const commPrice = get(community, 'priceLow') > 0 ? numeral(get(community, 'priceLow')).format('$0,0') : 'Coming Soon';

  return (
    <div className={styles} >
      <Link className="CommunityCompare_imageWrapper" style={{ backgroundImage: `url(${mapImage})` }} name="community-detail" community={community} />
      <div className="CommunityCompare_contentWrapper">
        <Link name="community-detail" community={community} >
          <h4 className="CommunityCompare_title">{get(community, 'name')}</h4>
          <h5 className="CommunityCompare_subtitle">{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')} {get(community, 'address.postalCode')}</h5>
        </Link>
        <ul className="CommunityCompare_bedsWrapper">
          {
            get(community, 'bedroom_range') &&
            <li>
              {get(community, 'bedroom_range')} Beds
            </li>
          }
          {
            get(community, 'bathroom_range') &&
            <li>
              {get(community, 'bathroom_range')} Baths
            </li>
          }
        </ul>
        <ul className="CommunityCompare_bedsWrapper">
          {
            get(community, 'sqftLow') &&
            <li>
              {numeral(get(community, 'sqftLow')).format('0,0')}-{numeral(get(community, 'sqftHigh')).format('0,0')} SQ FT
            </li>
          }
          <li>{commPrice}</li>
        </ul>
      </div>
    </div>
  );
}

CommunityCompareCard.propTypes = {
  community: PropTypes.object.isRequired,
};

export default CommunityCompareCard;



// WEBPACK FOOTER //
// ./src/components/CommunityCompareCard.js